import { useIntl } from 'react-intl';
import { useState, useMemo } from 'react';
import useAuth from 'src/hooks/useAuth';
import SearchBar from 'src/componentes/filtro/search-drawer/SearchBar';
import BasicsSection from './drawer-sections/BasicsSection';
import RiskSection from './drawer-sections/RiskSection';
import RelationshipsSection from './drawer-sections/RelationshipsSection';
import ToleranceSection from './drawer-sections/ToleranceSection';
import CustomFieldsSection from 'src/componentes/filtro/search-drawer/CustomFieldsSection';

const RiscoCategorizadoSearch = ({ model, configuracao }) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();
  const [searchQuery, setSearchQuery] = useState('');

  const showTolerance = useMemo(
    () => configuracao?.habilitarAcompanhamentoToleranciaRisco,
    [configuracao]
  );

  return (
    <>
      <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />

      <BasicsSection
        model={model}
        resources={resources}
        intl={intl}
        configuracao={configuracao}
        searchQuery={searchQuery}
      />

      <RiskSection
        model={model}
        resources={resources}
        intl={intl}
        configuracao={configuracao}
        searchQuery={searchQuery}
      />

      <RelationshipsSection
        model={model}
        resources={resources}
        intl={intl}
        configuracao={configuracao}
        searchQuery={searchQuery}
      />

      {showTolerance && (
        <ToleranceSection
          model={model}
          resources={resources}
          intl={intl}
          searchQuery={searchQuery}
          configuracao={configuracao}
        />
      )}

      <CustomFieldsSection
        model={model}
        intl={intl}
        searchQuery={searchQuery}
      />
    </>
  );
};
export default RiscoCategorizadoSearch;
